import dynamic from "next/dynamic";

import {
  parcelDetailsSchemaUa,
  parcelItemsSchemaUa,
} from "@/validations/parcel/parcelStepsUa.validation";
import { parcelServicesSchema } from "@/validations/parcel/parcelSteps.validation";

const ParcelItems = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/ua/parcel-items-ua"
    ),
  { ssr: false },
);
const ParcelDetails = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/ua/parcel-details-ua"
    ),
  { ssr: false },
);
const ParcelServices = dynamic(
  () =>
    import(
      "@/components/dashboard/parcels/modal/parcel-form-components/parcel-services"
    ),
  { ssr: false },
);

export const getParcelUk = [
  //* Note: Removed before there's "Send Parcel" too
  // {
  //   stepName: "add_parcel",
  //   component: <ShippingMethod />,
  //   validationSchema: parcelShippingMethodSchema,
  // },
  {
    stepName: "parcel_details",
    component: <ParcelDetails />,
    validationSchema: parcelDetailsSchemaUa,
  },
  {
    stepName: "item_details",
    component: <ParcelItems />,
    validationSchema: parcelItemsSchemaUa,
  },
  {
    stepName: "addon_services",
    component: <ParcelServices />,
    validationSchema: parcelServicesSchema,
  },
];
